(ns client-portal.client.oasys.data
  (:require [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:oasys])
(def assistants-path (conj root-path :assistants))

;; Placeholder list behind the header assistant picker — `/api/fake-assistants` is a
;; stub, so it takes no concept and returns the same ten assistants for everyone.
(re/reg-auth0-loader
  :oasys/load-assistants
  assistants-path
  {:method :get
   :url "/api/fake-assistants"}
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords))
                         []))
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :oasys/assistants-
  assistants-path
  :oasys/load-assistants)

(re/reg-sub
  :oasys/assistant-id-
  :<- [:router/current-query-params-]
  (fn [qps]
    (-> qps :assistant not-empty)))

(re/reg-event-db
  :oasys/select-assistant re/middleware
  (fn [db [assistant-id]]
    (re/dispatch [:router/go-with-merged-query-params
                  {:assistant assistant-id}])
    db))

(re/reg-sub
  :oasys/selected-assistant-
  :<- [:oasys/assistants-]
  :<- [:oasys/assistant-id-]
  (fn [[assistants assistant-id]]
    (when assistant-id
      (some #(when (= (:id %) assistant-id) %)
            (util/when-not-loading assistants)))))
